/**
 * @author Ahmed Samer
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2018-12-30
 * @description Implementation of the GraphQL mutation to refresh linked in users open id token.
 * @filename update-linked-in-user
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL mutation to refresh linked in user open id Token.
 *
 * @type {GraphQLTaggedNode}
 */
export const UPDATE_LINKEDIN_USER_GRAPHQL_MUTATION: GraphQLTaggedNode = graphql`
  mutation refreshLinkedInCredentialsMutation(
    $input: RefreshLinkedInCredentialsInput!
  ) {
    refreshLinkedInCredentials(input: $input) {
      clientMutationId
      credentials {
        id
        expires
        linkedInUserId
        openIdToken
      }
      hasErrors
      errors {
        created
        id
        location
        type
      }
    }
  }
`;
